'use client';

import React from 'react';
import LayoutIcon, { LayoutIcons } from './LayoutIcon';
import { AppUpdateColorScheme } from '@inway/layout/build/providers/AppContext';
import classNames from '@inway/classnames';
import Dropdown from 'react-bootstrap/esm/Dropdown';

export interface ColorSchemeSelectorDropdownProps {
  className?: string;
  preferredColorScheme: AppUpdateColorScheme;
  setPreferredColorScheme: (scheme: AppUpdateColorScheme) => void;
}

const UndecoratedToggle = React.forwardRef<
  HTMLButtonElement,
  React.PropsWithChildren<React.HTMLAttributes<HTMLButtonElement>>
>(({ className, children, onClick }, ref) => (
  <button
    ref={ref}
    className={classNames(
      'btn btn-link text-decoration-none text-body-secondary',
      className?.replaceAll('dropdown-toggle', '').trim()
    )}
    onClick={(e) => {
      e.preventDefault();
      if (onClick) onClick(e);
    }}
  >
    {children}
  </button>
));
UndecoratedToggle.displayName = 'UndecoratedToggle';

export function ColorSchemeSelectorDropdown({
  className,
  preferredColorScheme,
  setPreferredColorScheme,
}: ColorSchemeSelectorDropdownProps) {
  const schemeMap: Record<AppUpdateColorScheme, [LayoutIcons, string]> = {
    light: ['sunBright', 'Motyw jasny'],
    dark: ['moon', 'Motyw ciemny'],
    auto: ['moonOverSun', 'Motyw systemowy'],
  };
  const [icon, label] = schemeMap[preferredColorScheme];
  return (
    <Dropdown>
      <Dropdown.Toggle
        as={UndecoratedToggle}
        variant="link"
        className={className}
        title={label}
      >
        <LayoutIcon icon={icon} fixedWidth suppressHydrationWarning />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {(Object.keys(schemeMap) as AppUpdateColorScheme[]).map((scheme) => {
          const [schemeIcon, schemeLabel] = schemeMap[scheme];
          return (
            <Dropdown.Item
              key={scheme}
              active={scheme === preferredColorScheme}
              href="#"
              onClick={(ev) => {
                ev.preventDefault();
                if (setPreferredColorScheme) setPreferredColorScheme(scheme);
              }}
            >
              <LayoutIcon
                icon={schemeIcon}
                className="me-2"
                fixedWidth
                title={schemeLabel}
              />
              {schemeLabel}
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
}
